// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__5-RED","list":"Navigation_list__2ZMOY"};